/**
 * useWebSocket
 *
 * Composable for managing WebSocket connection lifecycle.
 * Handles connection, disconnection, and message callbacks.
 */

import { ref, onMounted, onUnmounted } from 'vue';
import { WebSocketClient, type MessageHandlers } from '@/core/WebSocketClient';

/**
 * @param url - WebSocket server URL
 * @param handlers - Message handlers
 */
export function useWebSocket(url: string, handlers: MessageHandlers) {
  const wsClient = new WebSocketClient();
  const wsConnected = ref(false);

  onMounted(() => {
    wsClient.connect(url, {
      ...handlers,
      onConnected: () => {
        wsConnected.value = true;
        handlers.onConnected?.();
      },
      onDisconnected: () => {
        wsConnected.value = false;
        handlers.onDisconnected?.();
      }
    });
  });

  onUnmounted(() => {
    wsClient.disconnect();
  });

  return {
    wsConnected,
    wsClient
  };
}
